export class InvoiceCreateDto{
    asnId:number
    invoiceData:any
    invoceNumber:string
    invoiceDueDate:any
}